import { NamedModelEntityReference } from '../../types';
import { CommonCompanyMetadata } from '../types';

export enum CompanyRelationType {
  COUNTRY_ORGANIZATION = 'COUNTRY_ORGANIZATION',
  SUBSIDIARY = 'SUBSIDIARY',
  PORTFOLIO_COMPANY = 'PORTFOLIO_COMPANY',
  BOND = 'BOND',
  OTHER = 'OTHER',
}

export const allCompanyRelationTypes = [
  CompanyRelationType.COUNTRY_ORGANIZATION,
  CompanyRelationType.SUBSIDIARY,
  CompanyRelationType.PORTFOLIO_COMPANY,
  CompanyRelationType.OTHER,
  CompanyRelationType.BOND,
];

export interface CompanyRelation extends CommonCompanyMetadata {
  targetCompanyId: string;
  type: CompanyRelationType;
  source: string;
  share?: number;
  lastModifiedBy?: number;
}

export type CompanyParentageByParentId = {
  [id: string]: NamedModelEntityReference[]; // Note that this is just a BFS-ordered list, any multi-parent hierarchy structure is not reflected here.
};

export type AncestorIdsByCompanyId = {
  [companyId: string]: string[];
};
